import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getTemplateList,addOrUpdateTemplate} from "../actions/report_template_action";

export default function ReportTemplatesContainer(component) {
    return connect(mapStateToProps, mapDispatchToProps)(component);
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({getTemplateList,addOrUpdateTemplate}, dispatch);
}

function mapStateToProps(state) {
    return {
        templates: state.reportTemplate.templates,
    };
}



// WEBPACK FOOTER //
// ./src/containers/report_template_container.js